import axios from 'axios'
import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/pagarbarbeiro.msg'
import MensagensHelper, { MSG_ALERTA } from '@/utils/mensagens.helper'
import ApiRotas from '@/modules/services/rotas.api'
import ServiceHandler from '@/modules/services/handler/service.handler'

class PagarBarbeiroService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('faturamentos', msg)
  }

  async buscaFiltroFuncionario(filtro) {
    const params = { params: { p: filtro } }
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/filtro/barbeiro`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default new PagarBarbeiroService()
